import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { IrbSettingsService } from '@irb/irb-settings/irb-settings.service';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-grid-lightning-icon-cell',
    template: `<div><img src="/assets/images/lighting_bolt_smartfilter.png"></div>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class lightningIconCellComponent implements AgRendererComponent {
    
    params: any;


    constructor() {}

    agInit(params: any) {
        this.params = params;

    }

    refresh(): boolean {
        return false;
    }

}
